export class CitiWeeklyInvoiceSearchCriteria {
  constructor() {
    //this.ADWeek = null;
    this.transactionType = 0;
  }
  ADWeek!: Date;
  transactionType: number;
}
